"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PricingBox;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _index3 = _interopRequireDefault(require("../../../experiments/animation/motion-move/index.js"));
const Box = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Box",
  class: "pl-bfmwc3d"
});
const BoxList = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BoxList",
  class: "pl-bytl5rv",
  vars: {
    "bytl5rv-2": [({
      columnCount = 1
    }) => columnCount]
  }
});
const Header = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Header",
  class: "pl-h1kdooge"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)(_index3.default)({
  name: "ButtonContainer",
  class: "pl-b1oyb8qa"
});

/**
 * PricingBox component.
 *
 * @param {Object} props React props
 * @param {String} props.tag Plantype Text
 * @param {String} props.heading Title text
 * @param {String} props.description Cta Props
 * @param {Number} props.itemColumnCount PricingBox children
 * @param {String} props.headlineSize PricingBox headline size
 * @param {String} props.headlineTag PricingBox headline tag
 * @param {Number} props.headlineLineLength PricingBox headline line length
 * @param {React.ReactElement} props.children Description Text
 * @param {React.ReactElement} props.cta Column Count for Each Box
 * @param {Boolean} props.invert Array of Layout Values
 * @param {String} props.controls Forwarded Headline Animate Props
 * @returns {React.ReactElement} PricingBox component
 * @public
 */

function PricingBox({
  tagText,
  tagDesign,
  tag,
  heading,
  description,
  itemColumnCount,
  children,
  cta,
  invert,
  partial,
  headlineSize = 'h5',
  headlineTag = 'h2',
  headlineLineLength = 1
}) {
  return /*#__PURE__*/_react.default.createElement(Box, {
    "data-partial": partial || (invert ? 'dark1' : ''),
    parentName: "pricing",
    className: "pricing-box"
  }, /*#__PURE__*/_react.default.createElement(Header, {
    parentName: "pricing-header"
  }, /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tag?.text ?? tagText,
    design: tag?.design ?? tagDesign
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: heading,
    headlineSize: headlineSize,
    headlineTag: headlineTag,
    headlineLineLength: headlineLineLength,
    description: description,
    textAlign: "center"
  })), /*#__PURE__*/_react.default.createElement(BoxList, {
    columnCount: itemColumnCount,
    parentName: "pricing-items"
  }, children), /*#__PURE__*/_react.default.createElement(ButtonContainer, {
    mode: "fluid",
    intensity: "300",
    variant: "moveDownFixed",
    parentName: "pricing-buttons",
    triggerOnce: true
  }, cta && /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: [cta]
  })));
}
PricingBox.propTypes = {
  tag: _propTypes.default.shape(_tag.default.propTypes),
  children: _propTypes.default.node,
  heading: _propTypes.default.string,
  description: _propTypes.default.string,
  itemColumnCount: _propTypes.default.oneOf([1, 2]),
  cta: _propTypes.default.object,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  controls: _propTypes.default.object,
  headlineSize: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  headlineLineLength: _propTypes.default.number,
  tagText: _propTypes.default.string,
  tagDesign: _propTypes.default.string
};